import { render, staticRenderFns } from "./LabProductManage.vue?vue&type=template&id=b5176fb8&scoped=true"
import script from "./LabProductManage.vue?vue&type=script&lang=js"
export * from "./LabProductManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5176fb8",
  null
  
)

export default component.exports